(() => {
  const INQUIRY_KEY = 'hakkenInquiryTarget';
  const SAMPLE_RETURN_KEY = 'hakkenSampleReturnUrl';
  const CONTACT_PATH = '/pages/contact';

  const normalizePath = (href) => {
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    } catch (_) {
      return '';
    }
  };

  const currentContext = () => {
    const context = window.HakkenPageContext || {};
    const lines = [];
    if (context.kind === 'product') {
      lines.push(context.title || document.title);
      if (context.code) {
        const codeLabel = context.templateSuffix === 'formula-sample'
          ? '処方番号'
          : context.templateSuffix === 'packaging-series'
            ? '容器番号'
            : '管理番号';
        lines.push(`${codeLabel}：${context.code}`);
      }
      const selectedOption = document.querySelector('.hakken-formula__sample-form select[name="id"] option:checked');
      const variant = selectedOption?.textContent?.trim() || context.variant;
      if (variant && variant !== 'Default Title') lines.push(`選択仕様：${variant}`);
    } else {
      lines.push(context.title || document.title);
    }
    if (context.url) lines.push(context.url);
    return lines.filter(Boolean).join('\n');
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link) return;

    if (normalizePath(link.href) === CONTACT_PATH) {
      const target = link.dataset.hakkenInquiryTarget || currentContext();
      if (target) sessionStorage.setItem(INQUIRY_KEY, target);
    }
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('hakken-formula__sample-form')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('[type="submit"]');
    const originalText = button?.innerHTML;
    if (button) button.disabled = true;

    try {
      const data = new FormData(form);
      const variantId = Number(data.get('id'));
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      const distinctVariants = new Set(cart.items.map((item) => Number(item.variant_id)));
      const existingItem = cart.items.find((item) => Number(item.variant_id) === variantId);
      const sampleMax = Math.max(1, Math.min(5, Number(form.querySelector('[data-sample-max]')?.value) || 1));
      if (!distinctVariants.has(variantId) && distinctVariants.size >= 5) {
        window.alert('サンプルは一度に5種類までお申し込みいただけます。カート内のサンプルをご確認ください。');
        return;
      }
      if (existingItem && Number(existingItem.quantity) >= sampleMax) {
        window.alert(`このサンプルは${sampleMax}点までお申し込みいただけます。カート内の数量をご確認ください。`);
        return;
      }

      sessionStorage.setItem(SAMPLE_RETURN_KEY, window.location.href);
      data.set('quantity', '1');
      const addResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!addResponse.ok) throw new Error('add_failed');
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (_) {
      window.alert('サンプルを追加できませんでした。時間をおいてもう一度お試しください。');
    } finally {
      if (button) {
        button.disabled = false;
        if (originalText) button.innerHTML = originalText;
      }
    }
  }, true);

  const continueLink = document.querySelector('[data-hakken-continue-samples]');
  if (continueLink) {
    const returnUrl = sessionStorage.getItem(SAMPLE_RETURN_KEY);
    if (returnUrl && new URL(returnUrl, window.location.origin).origin === window.location.origin) {
      continueLink.href = returnUrl;
    }
  }

  const targetField = document.querySelector('[data-hakken-inquiry-target-field]');
  if (targetField && !targetField.value.trim()) {
    const value = sessionStorage.getItem(INQUIRY_KEY);
    if (value) targetField.value = value;
  }
})();
